<template>
  <div
    class="row"
    :style="
      context == 'gp'
        ? 'margin-top: 15px; margin-bottom: 15px'
        : 'margin-bottom: 15px'
    "
  >
    <div :class="context == 'gp' ? 'col-6' : 'col-12'">
      <div style="padding-bottom: 40px">
        <div
          class="row w-100 ml-0 mr-0 totalsBoxLayout"
          style="margin: 20px auto 20px auto"
        >
          <div class="col-4" v-if="context == 'gp'">
            <div
              class="d-flex justify-content-center"
              style="padding-top: 20px; padding-bottom: 15px"
            >
              <div class="summaryFundTitle">Fund Size</div>
            </div>
            <div class="d-flex justify-content-center">
              <div class="summaryFundTitle">{{ fundSizeValue }}</div>
            </div>
          </div>
          <div :class="context == 'gp' ? 'col-8' : 'col-12'">
            <div class="row w-100 ml-0 mr-0 justify-content-center">
              <div style="margin-bottom: 20px; margin-top: 20px">
                <div class="totalsLpTitle" v-if="context == 'gp'">
                  Total Called
                </div>
                <div class="totalsLpTitle" v-if="context == 'lp'">Called</div>
              </div>
            </div>
            <div class="row w-100 ml-0 mr-0 justify-content-center">
              <div class="d-flex" style="margin-bottom: 20px">
                <div class="d-flex" style="margin-right: 66px">
                  <div class="totalsLpBody">Amount :</div>
                  <div class="totalsLpBody" style="margin-left: 5px">
                    ${{ totalAmountDollarAndPercentage.dollar }}
                  </div>
                </div>
                <div class="d-flex">
                  <div class="totalsLpBody">Called :</div>
                  <div class="totalsLpBody" style="margin-left: 5px">
                    {{ totalAmountDollarAndPercentage.percentage }}%
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="d-flex pb-2" style="justify-content: space-between">
          <div class="summaryCls"></div>
          <button
            class="newTask"
            @click="handleCreateCapitalCall"
            v-if="checkRole != 'Guest'"
          >
            <i class="fa fa-plus" aria-hidden="true"></i>Add
          </button>
        </div>
        <div id="theMainTableCapitalCalls">
          <div
            class="tabulator capitalCall-tabulator-cls"
            ref="capitalCallRefTable"
            style="width: 100%; height: 100%"
          ></div>
        </div>
      </div>
    </div>
    <div class="col-6" v-if="context == 'gp'"></div>
    <el-dialog
      left
      :title="capitalCallModalTitle"
      width="410px"
      style="margin: 0 auto"
      :closeOnClickModal="false"
      :closeOnPressEscape="false"
      @close="handleCancelCapitalCall"
      :showClose="!showCapitalCallSpinner"
      :visible.sync="showCapitalCallModal"
      class="investment-modal col-lg-12 col-sm-12 col-12 col-md-12"
    >
      <form @submit.prevent="handleSaveCapitalCall">
        <div class="row">
          <div class="col-12">
            <div class="formLabel">Last Call Date</div>
            <input
              class="todo-form-date todo-form form-control"
              type="date"
              :value="
                capitalCallDetails.last_call &&
                moment.utc(capitalCallDetails.last_call).format('YYYY-MM-DD')
                  ? moment
                      .utc(capitalCallDetails.last_call)
                      .format('YYYY-MM-DD')
                  : moment.utc(new Date()).format('YYYY-MM-DD')
              "
              @input="
                capitalCallDetails.last_call = moment($event.target.valueAsDate)
              "
            />
          </div>
        </div>
        <div class="row">
          <div class="col-12">
            <div class="formLabel">
              Amount %
              <span class="required">*</span>
            </div>
            <input
              type="Number"
              min="0"
              max="100"
              class="form-control team-form"
              style="width: 100%"
              v-model="capitalCallDetails.capital_called"
              placeholder="Amount %"
              @keyup="validations"
            />
          </div>
        </div>
        <div class="edit-company-action-button-row pt-3" style="margin: 0px">
          <button
            type="button"
            @click="handleCancelCapitalCall()"
            class="todo-form-cancel-button btn-outline-secondary"
          >
            Cancel
          </button>
          <!-- @click="registrarSave" -->
          <button
            type="submit"
            :disabled="showCapitalCallSpinner || saveDisable"
            class="todo-form-submit-button btn btn-primary"
            style="height: 35px"
          >
            Save
            <b-spinner
              v-if="showCapitalCallSpinner"
              style="float: right"
              small
              label="Loading..."
            ></b-spinner>
          </button>
        </div>
      </form>
    </el-dialog>
    <el-dialog
      center
      width="410px"
      :closeOnClickModal="false"
      :closeOnPressEscape="false"
      @close="handleCancelDelete"
      :showClose="!showDeleteSpinner"
      :visible.sync="showDeleteDialog"
    >
      <div class="row" style="padding-left: 15px; padding-right: 15px">
        <div style="padding-left: 30px">
          Are you sure you want to Delete this Capital Call?
        </div>
      </div>
      <div class="col-12 d-flex">
        <div
          class="col-xl edit-company-action-button-row"
          style="padding-right: 25px"
        >
          <button
            type="button"
            class="todo-form-cancel-button btn-outline-secondary"
            @click.prevent="handleCancelDelete"
            :disabled="showDeleteSpinner"
          >
            Cancel
          </button>
          <button
            type="submit"
            @click.prevent="handleDelete(deleteData)"
            class="todo-form-submit-button btn btn-primary"
            style="height: 35px"
            :disabled="showDeleteSpinner"
          >
            Delete
            <b-spinner
              v-if="showDeleteSpinner"
              style="float: right"
              small
              label="Loading..."
            ></b-spinner>
          </button>
        </div>
      </div>
    </el-dialog>
    <custom-menu></custom-menu>
  </div>
</template>
<script>
import moment from "moment";
import Tabulator from "tabulator-tables";
import CustomMenu from "../Components/CustomMenu.vue";
import { mapGetters } from "vuex";
import { Dialog, Select, Option } from "element-ui";
import { formatNumber, precisionNumberForamtter } from "../../../util";
export default {
  name: "CapitalCallTab",
  components: {
    [CustomMenu.name]: CustomMenu,
    [Dialog.name]: Dialog,
    [Select.name]: Select,
    [Option.name]: Option,
  },
  props: {
    context: String,
  },
  watch: {
    capitalCall: {
      handler: function (newData) {
        if (this.capitalCallTabulator) {
          this.capitalCallTabulator.replaceData(this.capitalCall.data);
        }
      },
    },
  },
  data() {
    return {
      capitalCallTabulator: null,
      capitalCallDetails: {},
      showCapitalCallModal: false,
      showCapitalCallSpinner: false,
      capitalCallModalTitle: "",
      saveDisable: true,
      showDeleteSpinner: false,
      showDeleteDialog: false,
      deleteData: {},
    };
  },
  computed: {
    ...mapGetters("lpAllocations", ["summaryData"]),
    ...mapGetters("lpAllocations", [
      "capitalCallData",
      "currentCapitalCallData",
      "thesisData",
      "fundDetailsData",
      "lpDetailsData",
      "detailsData",
    ]),
    ...mapGetters("user", ["currency"]),
    ...mapGetters("portfolio", ["portfolioData"]),
    ...mapGetters("role", ["checkRole"]),
    capitalCall() {
      return {
        data: this.capitalCallData,
        layout: "fitColumns",
        tooltips: true,
        layoutColumnsOnNewData: true,
        // index: "_id",
        tooltips: true,
        tooltipsHeader: true,
        placeholder: "No records to view",
        columns: this.capitalCallTableColumns,
      };
    },
    capitalCallTableColumns() {
      const self = this;
      let handleMenu = function (_cell, a, b) {
        _cell.getElement().addEventListener("click", () => {
          const ctxMenuData = [
            {
              title: "Edit",
              handler: () => {
                let data = _cell.getData();
                self.handleUpdateCapitalCall(data);
              },
            },
            {
              title: "Delete",
              handler: () => {
                let data = _cell.getData();
                self.deleteData = data;
                self.showDeleteDialog = true;
              },
            },
          ];
          self.$root.$emit("contextmenu", { event, ctxMenuData });
        });

        return `
        <i class="fas fa-ellipsis-v" style="color:#0000004D;"></i>
        `;
      };
      return [
        {
          title: "Call no.",
          field: "current_call",
          headerSort: false,
          resizable: true,
          // bottomCalc: function (values, data, calcParams) {
          //   //values - array of column values
          //   //data - all table data
          //   //calcParams - params passed from the column definition object
          //   return "TOTALS";
          // },
        },
        {
          title: "Date",
          field: "last_call",
          headerSort: false,
          resizable: true,
          formatter: function (cell, formatterParams) {
            return moment(cell.getData().last_call).format("MM/DD/YYYY");
          },
          tooltip: false,
        },
        {
          title: "Amount $",
          field: "capital_called_amount",
          headerSort: false,
          resizable: true,
          formatter: "money",
          formatterParams: this.currency.format,
          // bottomCalc: "sum",
          // bottomCalcFormatter: "money",
          // bottomCalcFormatterParams: this.currency.format,
          // bottomCalcParams: { precision: 2 },
        },
        {
          title: "% Called",
          field: "capital_called",
          headerSort: false,
          resizable: true,
          // bottomCalc: "sum",
          // bottomCalcParams: { precision: 2 },
          // bottomCalc: function (values, data, calcParams) {
          //   //values - array of column values
          //   //data - all table data
          //   //calcParams - params passed from the column definition object
          //   let retval = 0;
          //   data.map((item) => {
          //     if (
          //       item &&
          //       item.hasOwnProperty("capital_called") &&
          //       Number(item.capital_called) > 0
          //     ) {
          //       retval += Number(item.capital_called);
          //     }
          //   });
          //   return Number(retval) > 0 ? `${Number(retval).toFixed(2)}%` : "";
          // },
        },
        {
          width: "20",
          resizable: false,
          headerSort: false,
          responsive: 0,
          download: false,
          formatter: function (_cell, formatterParams) {
            if (self.checkRole == "Guest") {
              return "";
            }
            if (
              _cell.getData() &&
              _cell.getData().hasOwnProperty("showEllipses") &&
              _cell.getData().showEllipses == true
            ) {
              return handleMenu(_cell, formatterParams, formatterParams);
            } else {
              return "";
            }
          },
        },
      ];
    },
    moment() {
      return moment;
    },
    portfolioValue() {
      // sum up our portfolio value
      let sum = 0;
      if (this.portfolioData && this.portfolioData.length) {
        this.portfolioData.map((item) => {
          if (Number.isInteger(item.value)) sum += item.value;
        });
      }
      return sum;
    },
    portfolioCost() {
      // sum up our porfolio cost
      let sum = 0;
      if (this.portfolioData && this.portfolioData.length) {
        this.portfolioData.map((item) => {
          if (Number.isInteger(item.cost)) sum += item.cost;
        });
      }
      return sum;
    },
    totalAmountDollarAndPercentage() {
      let data = JSON.parse(JSON.stringify(this.capitalCallData));
      let retval = {
        percentage: 0,
        dollar: 0,
      };
      if (data && data.length > 0) {
        data.map((item) => {
          if (
            item &&
            item.hasOwnProperty("capital_called") &&
            Number(item.capital_called) > 0
          ) {
            retval.percentage += Number(item.capital_called);
          }
          if (
            item &&
            item.hasOwnProperty("capital_called_amount") &&
            Number(item.capital_called_amount) > 0
          ) {
            retval.dollar += Number(item.capital_called_amount);
          }
        });
      }
      retval.dollar =
        retval.dollar > 0 ? precisionNumberForamtter(retval.dollar, 1) : 0;
      return retval;
    },
    fundSizeValue() {
      let data = this.fundDetailsData;
      let retval =
        data &&
        data.length > 0 &&
        data[0].hasOwnProperty("capital_commitment") &&
        Number(data[0].capital_commitment) > 0
          ? `$${this.precisionNumberForamtter(
              Number(data[0].capital_commitment),
              1
            )}`
          : "$0";
      return retval;
    },
  },
  mounted() {
    if (this.$refs.capitalCallRefTable && this.capitalCall) {
      this.capitalCallTabulator = new Tabulator(
        this.$refs.capitalCallRefTable,
        this.capitalCall
      );
    }
  },
  methods: {
    refreshCapitalCallData() {
      const self = this;
      let data = self.$store.getters["lpAllocations/capitalCallData"];
      if (data) {
        this.capitalCallTabulator.replaceData(data);
      }
    },
    handleCancelCapitalCall() {
      this.capitalCallDetails = {};
      this.showCapitalCallModal = false;
      this.showCapitalCallSpinner = false;
      this.capitalCallModalTitle = "";
      this.saveDisable = true;
    },
    handleSaveCapitalCall() {
      const self = this;
      this.showCapitalCallSpinner = true;
      let serverData = JSON.parse(JSON.stringify(this.capitalCallDetails));
      serverData.capital_called = Number(serverData.capital_called);
      serverData.capital_called_amount =
        self.fundDetailsData &&
        self.fundDetailsData.length > 0 &&
        self.fundDetailsData[0].hasOwnProperty("capital_commitment") &&
        Number(self.fundDetailsData[0].capital_commitment) > 0
          ? Number(
              (
                Number(serverData.capital_called / 100) *
                Number(self.fundDetailsData[0].capital_commitment)
              ).toFixed(2)
            )
          : 0;
      if (this.capitalCallModalTitle == "Add Capital Call") {
        serverData.capital_called_to_date =
          self.currentCapitalCallData &&
          self.currentCapitalCallData.hasOwnProperty(
            "capital_called_to_date"
          ) &&
          Number(self.currentCapitalCallData.capital_called_to_date) > 0
            ? Number(self.currentCapitalCallData.capital_called_to_date) +
              Number(serverData.capital_called)
            : Number(serverData.capital_called);
        serverData.capital_called_to_date_amount =
          self.currentCapitalCallData &&
          self.currentCapitalCallData.hasOwnProperty(
            "capital_called_to_date_amount"
          ) &&
          Number(self.currentCapitalCallData.capital_called_to_date_amount) > 0
            ? Number(
                self.currentCapitalCallData.capital_called_to_date_amount
              ) + Number(serverData.capital_called_amount)
            : Number(serverData.capital_called_amount);
      } else {
        let previousCapitalCalledToDateAmountValue =
          self.currentCapitalCallData &&
          self.currentCapitalCallData.hasOwnProperty(
            "capital_called_to_date_amount"
          )
            ? Number(self.currentCapitalCallData.capital_called_to_date_amount)
            : 0;
        let previouCapitalCalledAmountValue =
          self.currentCapitalCallData &&
          self.currentCapitalCallData.hasOwnProperty("capital_called_amount")
            ? Number(self.currentCapitalCallData.capital_called_amount)
            : 0;
        let presentCapitalCalledToDateAmountValue = Number(
          (
            Number(previousCapitalCalledToDateAmountValue) -
            Number(previouCapitalCalledAmountValue)
          ).toFixed(2)
        );
        let previousCapitalCalledToDate =
          self.currentCapitalCallData &&
          self.currentCapitalCallData.hasOwnProperty("capital_called_to_date")
            ? Number(self.currentCapitalCallData.capital_called_to_date)
            : 0;
        let previousCapitalCalledValue =
          self.currentCapitalCallData &&
          self.currentCapitalCallData.hasOwnProperty("capital_called")
            ? Number(self.currentCapitalCallData.capital_called)
            : 0;
        let presentCapitalCalledToDateValue = Number(
          (
            Number(previousCapitalCalledToDate) -
            Number(previousCapitalCalledValue)
          ).toFixed(2)
        );
        serverData.capital_called_to_date_amount = Number(
          (
            Number(presentCapitalCalledToDateAmountValue) +
            Number(serverData.capital_called_amount)
          ).toFixed(2)
        );
        serverData.capital_called_to_date = Number(
          (
            Number(presentCapitalCalledToDateValue) +
            Number(serverData.capital_called)
          ).toFixed(2)
        );
      }
      serverData.current_call =
        this.capitalCallModalTitle == "Add Capital Call"
          ? `Call#${self.capitalCallData.length + 1}`
          : serverData.current_call;
      serverData.last_call = serverData.last_call
        ? serverData.last_call
        : new Date();
      let url =
        this.capitalCallModalTitle == "Add Capital Call"
          ? "lpAllocations/apiPostCapitalCallData"
          : "lpAllocations/apiPatchCapitalCallData";
      self.$store
        .dispatch(url, serverData)
        .then((data) => {
          self
            .updateLpDetails()
            .then((updateLpData) => {
              self
                .updateKpi()
                .then((updateKpi) => {
                  self.refreshCapitalCallData();
                  self
                    .updateSummaryData()
                    .then((updateSumaryData) => {
                      self.handleCancelCapitalCall();
                      self.$toaster.success("Saved Successfully");
                    })
                    .catch((error) => {
                      console.log(
                        "error in updateSummaryData inside capital call insert inside updatekpi promise",
                        error
                      );
                      this.$toaster.error("Fail to insert!!!");
                    });
                })
                .catch((error) => {
                  console.log(
                    "error in updatekpi inside capital call insert",
                    error
                  );
                  this.$toaster.error("Fail to insert!!!");
                });
            })
            .catch((error) => {
              console.log(
                "error in updateLpDetails inside capital call insert",
                error
              );
              this.$toaster.error("Fail to insert!!!");
            });
        })
        .catch((error) => {
          console.log("error in capital call insert", error);
          this.$toaster.error("Fail to insert!!!");
        });
    },
    validations() {
      if (
        this.capitalCallDetails &&
        this.capitalCallDetails.hasOwnProperty("capital_called") &&
        Number(this.capitalCallDetails.capital_called) > 0
      ) {
        this.saveDisable = false;
      } else {
        this.saveDisable = true;
      }
    },
    handleCreateCapitalCall() {
      this.capitalCallModalTitle = "Add Capital Call";
      this.capitalCallDetails = {};
      this.validations();
      this.showCapitalCallModal = true;
    },
    handleUpdateCapitalCall(rowData) {
      this.capitalCallModalTitle = "Edit Capital Call";
      this.capitalCallDetails = JSON.parse(JSON.stringify(rowData));
      this.validations();
      this.showCapitalCallModal = true;
    },
    updateKpi() {
      const self = this;
      let currentCapitalCallData =
        self.$store.getters["lpAllocations/currentCapitalCallData"];
      let fundDetailsData =
        self.$store.getters["lpAllocations/fundDetailsData"];
      let lpDetailsData = self.$store.getters["lpAllocations/lpDetailsData"];
      return new Promise((resolve, reject) => {
        let payload = JSON.parse(JSON.stringify(currentCapitalCallData));
        let totalLpCapitalCalled = 0;
        let totalLpDistributions = 0;
        let totalFundCapitalCalled =
          fundDetailsData &&
          fundDetailsData.length > 0 &&
          fundDetailsData[0].hasOwnProperty("capital_called") &&
          Number(fundDetailsData[0].capital_called) > 0
            ? Number(fundDetailsData[0].capital_called)
            : 0;
        let totalFundDistributions =
          fundDetailsData &&
          fundDetailsData.length > 0 &&
          fundDetailsData[0].hasOwnProperty("distributions") &&
          Number(fundDetailsData[0].distributions) > 0
            ? Number(fundDetailsData[0].distributions)
            : 0;
        if (lpDetailsData && lpDetailsData.length > 0) {
          lpDetailsData.map((item) => {
            if (
              item &&
              item.hasOwnProperty("capital_called") &&
              Number(item.capital_called) > 0
            ) {
              totalLpCapitalCalled += Number(item.capital_called);
            }
            if (
              item &&
              item.hasOwnProperty("distributions") &&
              Number(item.distributions) > 0
            ) {
              totalLpDistributions += Number(item.distributions);
            }
          });
          payload.moic =
            Number(this.portfolioValue) > 0 && Number(this.portfolioCost) > 0
              ? Number(
                  (
                    Number(this.portfolioValue) / Number(this.portfolioCost)
                  ).toFixed(2)
                )
              : 0;
          payload.tvpi =
            Number(totalLpCapitalCalled) > 0
              ? Number(
                  (
                    Number(this.portfolioValue) / Number(totalLpCapitalCalled)
                  ).toFixed(2)
                )
              : 0;
          payload.net_dpi =
            Number(totalLpCapitalCalled) > 0
              ? Number(
                  (
                    Number(totalLpDistributions) / Number(totalLpCapitalCalled)
                  ).toFixed(2)
                )
              : 0;
          payload.gross_dpi =
            Number(totalFundCapitalCalled) > 0
              ? Number(
                  (
                    Number(totalFundDistributions) /
                    Number(totalFundCapitalCalled)
                  ).toFixed(2)
                )
              : 0;
          if (payload.hasOwnProperty("_id")) {
            self.$store
              .dispatch("lpAllocations/apiPatchCapitalCallData", payload)
              .then((data) => {
                resolve(data);
              })
              .catch((error) => {
                reject(error);
              });
          } else {
            resolve();
          }
        } else {
          resolve();
        }
      });
    },
    updateLpDetails() {
      const self = this;
      let currentCapitalCallData =
        self.$store.getters["lpAllocations/currentCapitalCallData"];
      let detailsData = self.$store.getters["lpAllocations/detailsData"];
      let payload = [];
      return new Promise((resolve, reject) => {
        if (detailsData && detailsData.length > 0) {
          detailsData.map((item) => {
            let capitalCommitment =
              item.capital_commitment && Number(item.capital_commitment) > 0
                ? Number(item.capital_commitment)
                : 0;
            let contributedToDate =
              item.contributed_to_date && Number(item.contributed_to_date) > 0
                ? Number(item.contributed_to_date)
                : 0;
            item.capital_called =
              capitalCommitment &&
              currentCapitalCallData &&
              currentCapitalCallData.hasOwnProperty("capital_called_to_date") &&
              Number(currentCapitalCallData.capital_called_to_date)
                ? Number(
                    (
                      Number(capitalCommitment) *
                      (Number(currentCapitalCallData.capital_called_to_date) /
                        100)
                    ).toFixed(2)
                  )
                : 0;
            let capitalCalled =
              item.capital_called && Number(item.capital_called) > 0
                ? Number(item.capital_called)
                : 0;
            item.open_balance = Number(
              (Number(capitalCalled) - Number(contributedToDate)).toFixed(2)
            );
            //open balance=total_capital_called of each lp detail-contributed to date of each lp detail
            //remaining commitment=capital commitment of each lp detail-total_capital_called of each lp detail+open balance
            item.remaining_commitment = Number(
              (
                Number(capitalCommitment) -
                Number(capitalCalled) +
                Number(item.open_balance)
              ).toFixed(2)
            );
            payload.push(item);
          });
          self.$store
            .dispatch("lpAllocations/apiBulkPatchDetailsData", payload)
            .then((data) => {
              resolve(data);
            })
            .catch((error) => {
              reject(error);
            });
        } else {
          resolve();
        }
      });
    },
    updateSummaryData() {
      const self = this;
      let currentCapitalCallData =
        self.$store.getters["lpAllocations/currentCapitalCallData"];
      let fundDetailsData =
        self.$store.getters["lpAllocations/fundDetailsData"];
      return new Promise((resolve, reject) => {
        let serverData =
          self.summaryData && self.summaryData.length > 0
            ? JSON.parse(JSON.stringify(self.summaryData[0]))
            : {};
        serverData.capital_called =
          currentCapitalCallData &&
          currentCapitalCallData.hasOwnProperty("capital_called") &&
          Number(currentCapitalCallData.capital_called) > 0
            ? Number(currentCapitalCallData.capital_called)
            : 0;
        serverData.capital_called_to_date =
          currentCapitalCallData &&
          currentCapitalCallData.hasOwnProperty("capital_called_to_date") &&
          Number(currentCapitalCallData.capital_called_to_date) > 0
            ? Number(currentCapitalCallData.capital_called_to_date)
            : 0;
        serverData.capital_called_amount =
          currentCapitalCallData &&
          currentCapitalCallData.hasOwnProperty("capital_called_amount") &&
          Number(currentCapitalCallData.capital_called_amount) > 0
            ? Number(currentCapitalCallData.capital_called_amount)
            : 0;
        serverData.capital_called_to_date_amount =
          currentCapitalCallData &&
          currentCapitalCallData.hasOwnProperty(
            "capital_called_to_date_amount"
          ) &&
          Number(currentCapitalCallData.capital_called_to_date_amount) > 0
            ? Number(currentCapitalCallData.capital_called_to_date_amount)
            : 0;
        serverData.current_capital_call =
          currentCapitalCallData && currentCapitalCallData.hasOwnProperty("_id")
            ? currentCapitalCallData._id
            : "";
        serverData.moic =
          currentCapitalCallData &&
          currentCapitalCallData.hasOwnProperty("moic") &&
          Number(currentCapitalCallData.moic) > 0
            ? Number(currentCapitalCallData.moic)
            : 0;
        serverData.tvpi =
          currentCapitalCallData &&
          currentCapitalCallData.hasOwnProperty("tvpi") &&
          Number(currentCapitalCallData.tvpi) > 0
            ? Number(currentCapitalCallData.tvpi)
            : 0;
        serverData.net_dpi =
          currentCapitalCallData &&
          currentCapitalCallData.hasOwnProperty("net_dpi") &&
          Number(currentCapitalCallData.net_dpi) > 0
            ? Number(currentCapitalCallData.net_dpi)
            : 0;
        serverData.gross_dpi =
          currentCapitalCallData &&
          currentCapitalCallData.hasOwnProperty("gross_dpi") &&
          Number(currentCapitalCallData.gross_dpi) > 0
            ? Number(currentCapitalCallData.gross_dpi)
            : 0;
        serverData.capital_commitment =
          fundDetailsData &&
          fundDetailsData.length > 0 &&
          fundDetailsData[0].hasOwnProperty("capital_commitment") &&
          Number(fundDetailsData[0].capital_commitment) > 0
            ? Number(fundDetailsData[0].capital_commitment)
            : 0;
        if (self.summaryData && self.summaryData.length > 0) {
          if (serverData && serverData.hasOwnProperty("_id")) {
            self.$store
              .dispatch("lpAllocations/apiPatchSummaryData", serverData)
              .then((data) => {
                resolve(data);
              })
              .catch((error) => {
                reject(error);
              });
          } else {
            resolve();
          }
        } else {
          self.$store
            .dispatch("lpAllocations/apiPostSummaryData", serverData)
            .then((data) => {
              resolve(data);
            })
            .catch((error) => {
              reject(error);
            });
        }
      });
    },
    handleCancelDelete() {
      this.showDeleteSpinner = false;
      this.showDeleteDialog = false;
      this.deleteData = {};
    },
    handleDelete(serverData) {
      const self = this;
      if (serverData && serverData.hasOwnProperty("_id")) {
        this.showDeleteSpinner = true;
        self.$store
          .dispatch("lpAllocations/apiDeleteCapitalCallData", serverData)
          .then((deleteData) => {
            self.$store
              .dispatch("lpAllocations/apiFetchCapitalCallData")
              .then((data) => {
                self
                  .updateLpDetails()
                  .then((updateLpData) => {
                    self
                      .updateKpi()
                      .then((updateKpi) => {
                        self.refreshCapitalCallData();
                        self
                          .updateSummaryData()
                          .then((updateSumaryData) => {
                            self
                              .updateLastCallInDistributionData()
                              .then((distributionData) => {
                                self.handleCancelDelete();
                                self.$toaster.success("Deleted Successfully");
                              })
                              .catch((error) => {
                                console.log(
                                  "error in updateLastCallInDistributionData in updateSummaryData inside capital call delete inside updatekpi promise",
                                  error
                                );
                                this.$toaster.error("Fail to delete!!!");
                              });
                          })
                          .catch((error) => {
                            console.log(
                              "error in updateSummaryData inside capital call delete inside updatekpi promise",
                              error
                            );
                            this.$toaster.error("Fail to delete!!!");
                          });
                      })
                      .catch((error) => {
                        console.log(
                          "error in updatekpi inside capital call delete",
                          error
                        );
                        this.$toaster.error("Fail to delete!!!");
                      });
                  })
                  .catch((error) => {
                    console.log(
                      "error in updateLpDetails inside capital call delete",
                      error
                    );
                    this.$toaster.error("Fail to delete!!!");
                  });
              })
              .catch((error) => {
                console.log(
                  "error in getting capital call details after delete",
                  error
                );
                this.$toaster.error("Failed to delete!!!");
              });
          })
          .catch((error) => {
            console.log("error in deleting capital call", error);
            this.$toaster.error("Failed to delete!!!");
          });
      }
    },
    updateLastCallInDistributionData() {
      const self = this;
      let currentCapitalCallData =
        self.$store.getters["lpAllocations/currentCapitalCallData"];
      let currentDistributionData =
        self.$store.getters["lpAllocations/currentDistributionData"];
      return new Promise((resolve, reject) => {
        if (
          currentDistributionData &&
          currentDistributionData.hasOwnProperty("_id")
        ) {
          let serverData = JSON.parse(JSON.stringify(currentDistributionData));
          if (
            currentCapitalCallData &&
            currentCapitalCallData.hasOwnProperty("_id")
          ) {
            serverData.current_capital_call = currentCapitalCallData._id;
            self.$store
              .dispatch("lpAllocations/apiPatchDistributionData", serverData)
              .then((data) => {
                resolve(data);
              })
              .catch((error) => {
                reject(error);
              });
          } else {
            resolve();
          }
        } else {
          resolve();
        }
      });
    },
    precisionNumberForamtter: precisionNumberForamtter,
  },
};
</script>
<style>
.capitalCall-tabulator-cls .tabulator-footer .tabulator-calcs-holder {
  border-top: none;
}
.totalsBoxLayout {
  height: 102px;
  background: #ffffff 0% 0% no-repeat padding-box;
  border-radius: 6px;
  opacity: 1;
}
</style>